module.exports = __webpack_public_path__ + "fonts/iconfont.863e0f73.woff2";